export const MIN_AMOUNT = 0.01
export const MAX_EMAIL_LENGTH = 150
export const REQUIRED_FIELD_MESSAGE = 'Поле обязательно для заполнения'
export const INVALID_EMAIL_MESSAGE = 'Введён некорректный email'
export const INVALID_PHONE_MESSAGE = 'Введён некорректный номер телефона'
export const REQUIRED_SUM_FIELD_MESSAGE = 'Необходимо ввести сумму к оплате'
export const REQUIRED_EMAIL_FIELD_MESSAGE = 'Необходимо указать email'
